import React from 'react';
import styled from 'styled-components';
import { rhythm } from 'Themes/typography';
import { Input, FormControl, Grid } from '@material-ui/core';
import { takeInitials } from 'Utils';

const Container = styled.div`
  position: relative;
  height: 100%;
  min-height: 200px;
  padding: ${rhythm(0.3)} 0;
`;
const Heading = styled.h1`
  font-size: 1rem;
`;
const InnerContainer = styled.div`
  padding-bottom: ${rhythm(2.5)};
`;
const ContactContainer = styled.div`
  margin: ${rhythm(1)};
`;

const NotesGeneral = styled.div`
  padding: ${rhythm(0.3)} 0;
  font-family: Helvetica, Arial, sans-serif;
  padding-left: 5px;
  word-break: break-all;
`;
const Notes = styled.ol`
  type: '1';
`;

const Title = styled.div`
  font-weight: 600;
  font-size: 0.75rem;
`;

const Values = styled.div`
  padding-left: 4px;
  font-size: 0.875rem;
  color: #999a9a;
  display: inline-flex;
  align-items: center;
`;

const Image = styled.img`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  margin-left: 0.5rem;
`;

const ImagePlaceholder = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  margin-right: 0.5rem;
  background: blue;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
`;
const PadTop = styled.div`
  padding-top: ${rhythm(1)};
`;
const NoteNumb = styled.span`
  color: black;
  font-weight: bold;
`;
const Note = styled.p`
  display: block !important;
`;
const separateNotes = note => {
  if (note) {
    // const sanitizer = dompurify.sanitize;
    // let noteSanitizer = sanitizer(note);
    let noteSanitizer = note;
    let split = noteSanitizer.split('_$_');
    return split.map((el, index) => (
      <Note key={index}>
        <NoteNumb>{index + 1 + '. '}</NoteNumb> {el}
      </Note>
    ));
  }
};
const NoteAndUrl = ({
  onUrlAndNoteChange,
  note,
  noteError,
  urlError,
  url,
  isTicketExpired,
  shortlisted,
  notes,
  details,
  generalNotes,
}) => (
  <Container>
    <React.Fragment>
      <Heading>
        <div>General notes</div>
      </Heading>
      <NotesGeneral>{separateNotes(generalNotes)}</NotesGeneral>
      <div style={{ bottom: '0', position: 'absolute' }}>
        <Heading style={{ paddingTop: '100px' }}>Contact details</Heading>

        <ContactContainer>
          <Grid container spacing={8} alignItems="center">
            <Grid item xs={4}>
              <Title>Name:</Title>
            </Grid>
            <Grid item xs={8}>
              <Values>{details.manufacturer}</Values>
            </Grid>
          </Grid>
          {/* <Grid container spacing={8} alignItems="center">
            <Grid item xs={4}>
              <Title>Contact</Title>
            </Grid>
            <Grid item xs>
              <Values>
                {details.image ? (
                  <Image src={details.image} />
                ) : (
                  <ImagePlaceholder>
                    {takeInitials(details.contact)}
                  </ImagePlaceholder>
                )}
                <span>{details.contact}</span>
              </Values>
            </Grid>
          </Grid>
          <Grid container spacing={8} alignItems="center">
            <Grid item xs={4}>
              <Title>Email</Title>
            </Grid>
            <Grid item xs>
              <Values>{details.email}</Values>
            </Grid>
          </Grid> */}
          <Grid container spacing={8} alignItems="center">
            <Grid item xs={4}>
              <Title>Phone:</Title>
            </Grid>
            <Grid item xs={8}>
              <Values>{details.mobile}</Values>
            </Grid>
          </Grid>
        </ContactContainer>
      </div>
    </React.Fragment>
  </Container>
);

export default NoteAndUrl;
